import { createSelector } from 'reselect';
import { ReduxStore } from '../ducks';

export const pras = (state: ReduxStore) => state.pras;

export const prasSelector = createSelector(pras, (pras) => pras.pras);

export const prasErrorSelector = createSelector(pras, (pras) => pras.error);
